<template>
  <div v-if="auth.user.selectedAccess.roleLevel > 2">
    <app-header
      :title="
        $store.getters['translations/getLabel']('DISTRIBUTORS') ||
          'Distributors'
      "
    />
    <b-container>
      <DistributorList />
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import DistributorList from '@/components/DistributorList';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    DistributorList,
    AppHeader,
  },
  data() {
    return {
      auth: $auth,
    };
  },
};
</script>
